import React from 'react'
import { array } from 'prop-types'

import Type from '../Type'
import Grid from '../Grid'

import styles from './ArticlePartners.module.scss'
import ButtonStandard from '../ButtonStandard'

const ArticlePartners = ({ partners }) => {
  if (!partners || !partners.length) return null

  return (
    <div className={styles.ArticlePartners}>
      <Type size={['body2', 'body3']} weight="medium" className={styles.Title}>
        Our Partners
      </Type>
      <Grid flex>
        {partners.map((partner, i) => (
          <Grid.Item key={`partner${i}`} width={{ d: 1 / 3 }}>
            <div className={styles.Partner}>
              <Type
                size={['heading8', 'heading7']}
                className={styles.PartnerName}
              >
                {partner.name}
              </Type>
              <ButtonStandard
                className={styles.Button}
                size="small"
                outline
                icon="arrow-right"
                href={partner.website}
                target="_blank"
              >
                View profile
              </ButtonStandard>
            </div>
          </Grid.Item>
        ))}
      </Grid>
    </div>
  )
}

ArticlePartners.propTypes = {
  partners: array
}

export default ArticlePartners
